module.exports = __webpack_public_path__ + "images/feature/file-multi-version-2-1ada2d1e59a3f901009a642c62fcf0db.jpg";